const style = {
  tableWrapper: {
    sx: {
      margin: '32px 0px',
    },
  },
  paddings: {
    pt64: {
      paddingTop: '64px',
    },
  },
  container: {
    maxSize: 'lg',
  },
} as const;

export default style;
